import { render, staticRenderFns } from "./AuthView.vue?vue&type=template&id=4e5f5d66&"
import script from "./AuthView.vue?vue&type=script&lang=js&"
export * from "./AuthView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QPage,QDialog,QCard,QCardSection,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QPage,QDialog,QCard,QCardSection,QCardActions,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
